import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../utils/axiosInstance";
import Session from "../utils/sessionStorage";
import { CiBarcode } from "react-icons/ci";
import ScannerModal from "../components/ScannerModal";
import { countries } from "../constants";
import Input from "../components/form/Input";
import ErrorModal from "../components/ErrorModal";
import SuccessModal from "../components/SuccessModal";
import loadingimage from "../assets/gifs/loading (1).gif";

const MNPForm = () => {
  const location = useLocation();
  const { extractedData, documentType, selectedDonor } = location.state || {};
  const doctype = documentType ? documentType.toUpperCase() : "";
  const isPassport = doctype === "PASSPORT";
  console.log("dara: ", extractedData)
  console.log("slected donor in form : ", selectedDonor)
  const [states, setStates] = useState([]);
  const [availableNos, setAvailableNos] = useState([]);
  const [sameAddress, setSameAddress] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [cobrands, setCobrands] = useState([]);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const token = Session.get("token");
  const navigate = useNavigate();

  const [form, setForm] = useState({
    full_name: "",
    first_name: "",
    email: "",
    date_of_birth: "",
    identity_type: doctype || "",
    identity_no: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    postal_code: "",
    msisdn: "",
    iccid: "",
    // Additional fields for passport
    foreigner_type: "",
    alt_mobile_no: "",
    issuance_country: "",
    stay_address_1: "",
    stay_address_2: "",
    stay_city: "",
    stay_postal_code: "",
    stay_state: "",
    ugu_ref_code: "",
    // Student fields
    institute_name: "",
    institute_address_1: "",
    institute_address_2: "",
    institute_city: "",
    institute_postal_code: "",
    institute_state: "",
    institute_ref_no: "",
    // Worker fields
    employer_name: "",
    employer_address_1: "",
    employer_address_2: "",
    employer_city: "",
    employer_postal_code: "",
    employer_state: "",
    emp_ref_no: "",
    // Tourist field
    hotel_name: "",
    co_brand: "",
    dealer_id: "",
    contact_no: "",
    gender: "",
    donor_id: selectedDonor || "",
    sub_donor: selectedDonor || "",
    race: "",
  });

  // Fetch states and available numbers on component mount
  useEffect(() => {
    async function getStates() {
      try {
        const response = await axiosInstance.get("api/v1/get-states", {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.status === 200) {
          setStates(response.data.states);
        }
      } catch (error) {
        setErrorMessage(error?.response?.data?.message || "Failed to load states");
        setShowError(true);
      }
    }

    async function getAvailableNos() {
      try {
        const response = await axiosInstance.get("api/v1/available-numbers", {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.status === 200) {
          setAvailableNos(response.data.available_numbers);
        }
      } catch (error) {
        setErrorMessage(error?.response?.data?.message || "Failed to load available numbers");
        setShowError(true);
      }
    }

    async function getCobrands() {
      try {
        const response = await axiosInstance.get("api/v1/get-cobrand-details", {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.status === 200) {
          setCobrands(response.data.cobrand_details);
        }
      } catch (error) {
        setErrorMessage(error?.response?.data?.message || "Failed to load cobrand details");
        setShowError(true);
      }
    }

    getCobrands();
    getStates();
    getAvailableNos();
  }, [token]);

  useEffect(() => {
    if (extractedData) {
      const extractedFields = extractedData.front
        ? extractedData.front.extracted_data
        : extractedData.extracted_data;

      const first_name = extractedFields.first_name || "";
      const lastName = extractedFields.last_name || "";

      const extractedState = extractedFields.state || "";
      const matchedState = states.find(
        state => state.name.toUpperCase() === extractedState.toUpperCase()
      );

      const extractedCountry = extractedFields.issue_country || extractedFields.issue_country_abb || "";
      const matchedCountry = countries.find(
        country =>
          country.name.toUpperCase() === extractedCountry.toUpperCase() ||
          country.code.toUpperCase() === extractedCountry.toUpperCase()
      );

      setForm(prev => ({
        ...prev,
        first_name: first_name,
        full_name: `${first_name} ${lastName}`.trim(),
        identity_no: extractedFields.nric || extractedFields.passport_no || "",
        address1: extractedFields.address || "",
        postal_code: extractedFields.zip_code || "",
        state: matchedState ? matchedState.code : "",
        city: extractedFields.city || "",
        date_of_birth: extractedFields.date_of_birth || "",
        // For passport
        issuance_country: matchedCountry ? matchedCountry.code : "",
      }));
      const currentFormData = JSON.parse(sessionStorage.getItem('mnpRegisterForm') || '{}');
      const updatedFormData = {
        ...currentFormData,
        first_name: first_name,
        full_name: `${first_name} ${lastName}`.trim(),
      };
      sessionStorage.setItem('mnpRegisterForm', JSON.stringify(updatedFormData));
    }
  }, [extractedData, states]);

  useEffect(() => {
    if (sameAddress && isPassport) {
      setForm((prev) => ({
        ...prev,
        address1: prev.stay_address_1,
        address2: prev.stay_address_2,
        city: prev.stay_city,
        state: prev.stay_state,
        postal_code: prev.stay_postal_code,
      }));
    }
  }, [
    sameAddress,
    isPassport,
    form.stay_address_1,
    form.stay_address_2,
    form.stay_city,
    form.stay_state,
    form.stay_postal_code,
  ]);

  useEffect(() => {
    const savedFormData = sessionStorage.getItem('mnpRegisterForm');
    if (savedFormData) {
      const parsedData = JSON.parse(savedFormData);
      setForm(prev => ({
        ...prev,
        full_name: parsedData.full_name || "",
        first_name: parsedData.first_name || "",
        iccid: parsedData.iccid || "",
        msisdn: parsedData.msisdn || ""
      }));
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: value
    }));

    // Save specific fields to session storage
    if (name === 'full_name' || name === 'first_name' || name === 'iccid' || name === 'msisdn') {
      const currentFormData = JSON.parse(sessionStorage.getItem('mnpRegisterForm') || '{}');
      const updatedFormData = {
        ...currentFormData,
        [name]: value
      };
      sessionStorage.setItem('mnpRegisterForm', JSON.stringify(updatedFormData));
    }

  };

  const validateForm = () => {
    if (!form.co_brand) return "Co-brand is required";
    if (!form.full_name) return "Full Name is required";
    if (!form.first_name) return "First Name is required";
    if (!form.gender) return "Gender is required";

    if (!form.email) {
      return "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      return "Please enter a valid email address";
    }
    if (!form.contact_no) {
      return "Contact Number is required"
    } else if (!/^\d+$/.test(form.contact_no)) {
      return "Contact should contain only digits";
    };

    if (!form.date_of_birth) return "Date of Birth is required";
    if (!form.identity_type) return "Identity Type is required";
    if (!form.race) return "Race is required";
    if (!form.identity_no) return "Identity Number is required";
    if (!form.address1) return "Address Line 1 is required";
    if (!form.city) return "City is required";
    if (!form.state) return "State is required";
    if (!form.postal_code) return "Postcode is required";

    if (!form.iccid) {
      return "ICCID is required";
    } else if (!/^\d+$/.test(form.iccid)) {
      return "ICCID should contain only digits";
    }

    if (!form.msisdn) {
      return "Mobile Number is required";
    } else if (!/^(60)?[0-9]{8,11}$/.test(form.msisdn)) {
      return "Please enter a valid Malaysian phone number (60XXXXXXXXX)";
    }

    // Additional validation for passport
    if (isPassport) {
      if (!form.foreigner_type) return "Foreigner type is required";
      if (!form.issuance_country) return "Issuance country is required";
      if (!form.stay_address_1) return "Staying address is required";
      if (!form.stay_city) return "Staying city is required";
      if (!form.stay_state) return "Staying state is required";
      if (!form.stay_postal_code) return "Staying postcode is required";



      if (form.alt_mobile_no && !/^\d+$/.test(form.alt_mobile_no)) {
        return "Alternate mobile should contain only digits";
      }

      // Validation based on foreigner type
      if (form.foreigner_type === "Student") {
        if (!form.institute_name) return "Institute name is required";
        if (!form.institute_address_1) return "Institute address is required";
        if (!form.institute_city) return "Institute city is required";
        if (!form.institute_postal_code) return "Institute postcode is required";
        if (!form.institute_state) return "Institute state is required";
      } else if (form.foreigner_type === "Worker") {
        if (!form.employer_name) return "Employer name is required";
        if (!form.employer_address_1) return "Employer address is required";
        if (!form.employer_city) return "Employer city is required";
        if (!form.employer_postal_code) return "Employer postcode is required";
        if (!form.employer_state) return "Employer state is required";
      } else if (form.foreigner_type === "Tourist") {
        if (!form.hotel_name) return "Hotel name is required";
      }
    }

    return null; // No errors
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const validationError = validateForm();
    if (validationError) {
      setErrorMessage(validationError);
      setShowError(true);
      setLoading(false);
      // Find and focus the first invalid field
      const fieldName = validationError.split(" ")[0].toLowerCase();
      const inputElement = document.querySelector(`[name="${fieldName}"]`);
      if (inputElement) {
        inputElement.focus();
      }
      return;
    }

    try {
      const body = {
        msisdn: form.msisdn,
        full_name: form.full_name,
        first_name: form.first_name,
        date_of_birth: form.date_of_birth ? form.date_of_birth.replace(/-/g, "") : "",
        address1: form.address1,
        address2: form.address2,
        state: form.state,
        city: form.city,
        postal_code: form.postal_code,
        email: form.email,
        plan_info: "JS", // Adjust if needed
        identity_type: form.identity_type === 'MYKAD' ? 'NRIC' : form.identity_type,
        identity_no: form.identity_no,
        iccid: form.iccid,
        issuance_country: form.issuance_country,
        alt_mobile_no: form.alt_mobile_no,
        stay_address_1: form.stay_address_1,
        stay_address_2: form.stay_address_2,
        stay_city: form.stay_city,
        stay_state: form.stay_state,
        stay_postal_code: form.stay_postal_code,
        ugu_ref_code: form.ugu_ref_code,
        co_brand: form.co_brand,
        dealer_id: form.dealer_id,
        contact_no: form.contact_no,
        gender: form.gender,
        donor_id: form.donor_id,
        sub_donor: form.sub_donor,
        race: form.race,
      };
      if (extractedData) {
        if (extractedData.front) {
          // MyKad with front/back scans
          body.mykad_front = extractedData.front.extracted_data.url;
          body.mykad_back = extractedData.back.extracted_data.url;
        } else {
          // Passport single scan
          body.passport = extractedData.extracted_data.url;
        }
      }

      if (isPassport) {
        body.foreigner_type = form.foreigner_type;

        switch (form.foreigner_type) {
          case 'Student':
            Object.assign(body, {
              institute_name: form.institute_name,
              institute_address_1: form.institute_address_1,
              institute_address_2: form.institute_address_2,
              institute_city: form.institute_city,
              institute_state: form.institute_state,
              institute_postal_code: form.institute_postal_code,
              institute_ref_no: form.institute_ref_no,
            });
            break;
          case 'Worker':
            Object.assign(body, {
              employer_name: form.employer_name,
              employer_address_1: form.employer_address_1,
              employer_address_2: form.employer_address_2,
              employer_city: form.employer_city,
              employer_state: form.employer_state,
              employer_postal_code: form.employer_postal_code,
              emp_ref_no: form.emp_ref_no,
            });
            break;
          case 'Tourist':
            Object.assign(body, {
              hotel_name: form.hotel_name,
            });
            break;
          default:
            break;
        }
      }

      console.log("FINAL DATA : ", body)
      const response = await axiosInstance.post('api/v1/register-mnp', body, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        setSuccessMessage(response.data.message || "MNP registered successfully!");
        setShowSuccess(true);
        // Navigate will happen after modal close
      }
    } catch (error) {
      console.log("errrrrrrr:", error)
      setErrorMessage(error?.response?.data?.message || "Registration failed. Please try again.");
      setShowError(true);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenBarCodeModal = () => {
    setOpenModal(true);
  };

  const closeModal = () => {
    setOpenModal(false);
  };

  const getCode = (code) => {
    if (code) {
      setForm(prev => ({
        ...prev,
        iccid: code,
      }));
    }
  };

  return (
    <>
      <Header />
      <div className="max-w-md my-6 px-4 mx-auto bg-white rounded-lg ">
        <form onSubmit={handleSubmit} className="space-y-4">
          {          /* CoBrand */}
          {/* CoBrand */}
          <div>
            <label className="block text-[13px] font-medium text-gray-700">CoBrand <span className="text-red-500">*</span></label>
            <select
              autoComplete="off"
              name="co_brand"
              value={form.co_brand}
              onChange={(e) => {
                const selectedIndex = e.target.selectedIndex;
                const selectedOption = cobrands[selectedIndex - 1]; // -1 to account for the default option
                setForm(prev => ({
                  ...prev,
                  co_brand: e.target.value,
                  dealer_id: selectedOption ? selectedOption.DealerId : ""
                }));
              }}
              className="font-poppins w-full p-3 outline-none bg-transparent text-[#1111117A] border-[1px] border-[#11111126] rounded-[8px] border-accent-silver-300 focus:ring-blue-500 focus:border-blue-500  placeholder:text-base placeholder:font-normal text-accent-silver-900 placeholder:text-accent-silver-900"
            >
              <option value="">Select CoBrand</option>
              {cobrands.map((brand, index) => (
                <option key={index} value={brand.coBrand}>
                  {brand.coBrand}
                </option>
              ))}
            </select>
          </div>
          {/* Full Name */}
          <div>
            <label className="block text-[13px] font-medium text-gray-700">Full Name <span className="text-red-500">*</span></label>
            <input
              autoComplete="off"
              type="text"
              name="full_name"
              value={form.full_name}
              onChange={handleChange}
              className="mt-1 block w-full min-h-[50px] border-[1px] border-[#11111126] rounded-[8px] text-[#1111117A] shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            />
          </div>

          {/* First Name */}
          <div>
            <label className="block text-[13px] font-medium text-gray-700">First Name <span className="text-red-500">*</span></label>
            <input
              autoComplete="off"
              type="text"
              name="first_name"
              value={form.first_name}
              onChange={handleChange}
              className="mt-1 block w-full min-h-[50px] border-[1px] border-[#11111126] rounded-[8px] text-[#1111117A] shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            />
          </div>
          {/* Gender */}
          <div>
            <label className="block text-[13px] font-medium text-gray-700">Gender <span className="text-red-500">*</span></label>
            <select
              autoComplete="off"
              name="gender"
              value={form.gender}
              onChange={handleChange}
              className="font-poppins w-full p-3 outline-none bg-transparent text-[#1111117A] border-[1px] border-[#11111126] rounded-[8px] border-accent-silver-300 focus:ring-blue-500 focus:border-blue-500  placeholder:text-base placeholder:font-normal text-accent-silver-900 placeholder:text-accent-silver-900"
            >
              <option value="">Select Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>

            </select>
          </div>

          {/* Email */}
          <div>
            <label className="block text-[13px] font-medium text-gray-700">Email <span className="text-red-500">*</span></label>
            <input
              autoComplete="off"
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              className="mt-1 block w-full min-h-[50px] border-[1px] border-[#11111126] rounded-[8px] text-[#1111117A] shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            />
          </div>

          {/* Contact Number */}
          <div>
            <label className="block text-[13px] font-medium text-gray-700">Contact Number <span className="text-red-500">*</span></label>
            <input
              autoComplete="off"
              type="text"
              name="contact_no"
              value={form.contact_no}
              onChange={handleChange}
              className="mt-1 block min-h-[50px] w-full border-[1px] border-[#11111126] rounded-[8px] text-[#1111117A] shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            />
          </div>

          {/* Date of Birth */}
          <div>
            <label className="block text-[13px] font-medium text-gray-700">Date of Birth <span className="text-red-500">*</span></label>

            <div className="mt-1 box-border flex h-[50px] w-full min-w-0 items-center rounded-[8px] border border-[#11111126] px-3 focus-within:border-blue-500">
              <Input
                autoComplete="off"
                type={"date"}
                name={"date_of_birth"}
                intent={"secondary"}
                size={"lg"}
                placeholder={"dob"}
                roundness={"round-sm"}
                classes={"!p-0 !border-0 box-border h-full w-full min-w-0 max-w-full text-[#1111117A]"}
                value={form?.date_of_birth}
                selector={"dob"}
                eventAction={handleChange}
              />
            </div>
          </div>

          {/* Identity Type */}
          <div>
            <label className="block text-[13px] font-medium text-gray-700">Identity Type <span className="text-red-500">*</span></label>
            <select
              autoComplete="off"
              name="identity_type"
              value={form.identity_type}
              onChange={handleChange}
              className="font-poppins w-full p-3 rounded-[8px] outline-none bg-transparent text-[#1111117A] border-[1px] border-[#11111126] focus:ring-blue-500 focus:border-blue-500  placeholder:text-base placeholder:font-normal text-accent-silver-900 placeholder:text-accent-silver-900"
            >
              <option value="">Select Identity Type</option>
              <option value="MYKAD">MYKAD</option>
              <option value="PASSPORT">Passport</option>
            </select>
          </div>

          {/* First Name */}
          <div>
            <label className="block text-[13px] font-medium text-gray-700">Race <span className="text-red-500">*</span></label>
            <select
              autoComplete="off"
              name="race"
              value={form.race}
              onChange={handleChange}
              className="font-poppins w-full p-3 rounded-[8px] outline-none bg-transparent text-[#1111117A] border-[1px] border-[#11111126] focus:ring-blue-500 focus:border-blue-500  placeholder:text-base placeholder:font-normal text-accent-silver-900 placeholder:text-accent-silver-900"
            >
              <option value="">Select Race</option>
              <option value="MALAY">MALAY</option>
              <option value="CHINESE">CHINESE</option>
              <option value="INDIAN">INDIAN</option>
              <option value="OTHERS">OTHERS</option>
            </select>
          </div>

          {/* Identity Number */}
          <div>
            <label className="block text-[13px] font-medium text-gray-700">Identity Number <span className="text-red-500">*</span></label>
            <input
              autoComplete="off"
              type="text"
              name="identity_no"
              value={form.identity_no}
              onChange={handleChange}
              className="mt-1 block min-h-[50px] w-full border-[1px] border-[#11111126] rounded-[8px] text-[#1111117A] shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            />
          </div>

          {/* Additional fields for passport */}
          {isPassport && (
            <>
              {/* Foreigner Type */}
              <div>
                <label className="block text-[13px] font-medium text-gray-700">Foreigner Type <span className="text-red-500">*</span></label>
                <select
                  autoComplete="off"
                  name="foreigner_type"
                  value={form.foreigner_type}
                  onChange={handleChange}
                  className="font-poppins w-full p-3 rounded-[8px] outline-none bg-transparent text-[#1111117A] border-[1px] border-[#11111126] focus:ring-blue-500 focus:border-blue-500  placeholder:text-base placeholder:font-normal text-accent-silver-900 placeholder:text-accent-silver-900"
                >
                  <option value="">Select Foreigner Type</option>
                  <option value="Student">Student</option>
                  <option value="Worker">Worker</option>
                  <option value="Tourist">Tourist</option>
                </select>
              </div>

              {/* Alternate Mobile */}
              <div>
                <label className="block text-[13px] font-medium text-gray-700">Alternate Mobile</label>
                <input
                  autoComplete="off"
                  type="text"
                  name="alt_mobile_no"
                  value={form.alt_mobile_no}
                  onChange={handleChange}
                  className="mt-1 block min-h-[50px] w-full border-[1px] border-[#11111126] rounded-[8px] text-[#1111117A] shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              {/* Issuance Country */}
              <div>
                <label className="block text-[13px] font-medium text-gray-700">Issuance Country <span className="text-red-500">*</span></label>
                {/* {form.identity_type === "PASSPORT" ? ( */}
                <select
                  autoComplete="off"
                  name="issuance_country"
                  value={form.issuance_country}
                  onChange={handleChange}
                  className="font-poppins w-full p-3 rounded-[8px] outline-none bg-transparent text-[#1111117A] border-[1px] border-[#11111126] focus:ring-blue-500 focus:border-blue-500  placeholder:text-base placeholder:font-normal text-accent-silver-900 placeholder:text-accent-silver-900"
                >
                  <option value="">Select Issuance Country</option>
                  {countries.map((country) => (
                    <option key={country.code} value={country.code}>
                      {country.name} ({country.code})
                    </option>
                  ))}
                </select>
                {/* ) : ( */}
                {/* <input
                                        name="issuance_country"
                                        value="MY"
                                        disabled
                                        className="mt-1 block w-full border-2 border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 bg-gray-100"
                                    />
                                )} */}
              </div>

              {/* Staying Address 1 */}
              <div>
                <label className="block text-[13px] font-medium text-gray-700">Staying Address Line 1 <span className="text-red-500">*</span></label>
                <input
                  autoComplete="off"
                  type="text"
                  name="stay_address_1"
                  value={form.stay_address_1}
                  onChange={handleChange}
                  className="mt-1 min-h-[50px] block w-full border-[1px] border-[#11111126] rounded-[8px] text-[#1111117A] shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              {/* Staying Address 2 */}
              <div>
                <label className="block text-[13px] font-medium text-gray-700">Staying Address Line 2</label>
                <input
                  autoComplete="off"
                  type="text"
                  name="stay_address_2"
                  value={form.stay_address_2}
                  onChange={handleChange}
                  className="mt-1 min-h-[50px] block w-full border-[1px] border-[#11111126] rounded-[8px] text-[#1111117A] shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              {/* Staying City */}
              <div>
                <label className="block text-[13px] font-medium text-gray-700">Staying City <span className="text-red-500">*</span></label>
                <input
                  autoComplete="off"
                  type="text"
                  name="stay_city"
                  value={form.stay_city}
                  onChange={handleChange}
                  className="mt-1 min-h-[50px] block w-full border-[1px] border-[#11111126] rounded-[8px] text-[#1111117A] shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              {/* Staying State */}
              <div>
                <label className="block text-[13px] font-medium text-gray-700">Staying State <span className="text-red-500">*</span></label>
                <select
                  autoComplete="off"
                  name="stay_state"
                  value={form.stay_state}
                  onChange={handleChange}
                  className="font-poppins w-full p-3 rounded-[8px] outline-none bg-transparent text-[#1111117A] border-[1px] border-[#11111126] focus:ring-blue-500 focus:border-blue-500  placeholder:text-base placeholder:font-normal text-accent-silver-900 placeholder:text-accent-silver-900"
                >
                  <option value="">Select State</option>
                  {states.map((state) => (
                    <option key={state.code} value={state.code}>
                      {state.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Staying Postcode */}
              <div>
                <label className="block text-[13px] font-medium text-gray-700">Staying Postcode <span className="text-red-500">*</span></label>
                <input
                  autoComplete="off"
                  type="text"
                  name="stay_postal_code"
                  value={form.stay_postal_code}
                  onChange={handleChange}
                  className="mt-1 min-h-[50px] block w-full border-[1px] border-[#11111126] rounded-[8px] text-[#1111117A] shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              <div>
                <label className="block text-[13px] font-medium text-gray-700">Referral Code</label>
                <input
                  autoComplete="off"
                  type="text"
                  name="ugu_ref_code"
                  value={form.ugu_ref_code}
                  onChange={handleChange}
                  className="mt-1 min-h-[50px] block w-full border-[1px] border-[#11111126] rounded-[8px] text-[#1111117A] shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              {/* Additional fields based on foreigner type */}
              {form.foreigner_type === "Student" && (
                <>
                  <div>
                    <label className="block text-[13px] font-medium text-gray-700">Institute Name <span className="text-red-500">*</span></label>
                    <input
                      autoComplete="off"
                      type="text"
                      name="institute_name"
                      value={form.institute_name}
                      onChange={handleChange}
                      className="mt-1 min-h-[50px] block w-full border-[1px] border-[#11111126] rounded-[8px] text-[#1111117A] shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-[13px] font-medium text-gray-700">Institute Address Line 1 <span className="text-red-500">*</span></label>
                    <input
                      autoComplete="off"
                      type="text"
                      name="institute_address_1"
                      value={form.institute_address_1}
                      onChange={handleChange}
                      className="mt-1 min-h-[50px] block w-full border-[1px] border-[#11111126] rounded-[8px] text-[#1111117A] shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-[13px] font-medium text-gray-700">Institute Address Line 2</label>
                    <input
                      autoComplete="off"
                      type="text"
                      name="institute_address_2"
                      value={form.institute_address_2}
                      onChange={handleChange}
                      className="mt-1 min-h-[50px] block w-full border-[1px] border-[#11111126] rounded-[8px] text-[#1111117A] shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-[13px] font-medium text-gray-700">Institute City <span className="text-red-500">*</span></label>
                    <input
                      autoComplete="off"
                      type="text"
                      name="institute_city"
                      value={form.institute_city}
                      onChange={handleChange}
                      className="mt-1 min-h-[50px] block w-full border-[1px] border-[#11111126] rounded-[8px] text-[#1111117A] shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-[13px] font-medium text-gray-700">Institute Postcode <span className="text-red-500">*</span></label>
                    <input
                      autoComplete="off"
                      type="text"
                      name="institute_postal_code"
                      value={form.institute_postal_code}
                      onChange={handleChange}
                      className="mt-1 block min-h-[50px] w-full border-[1px] border-[#11111126] rounded-[8px] text-[#1111117A] shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-[13px] font-medium text-gray-700">Institute State <span className="text-red-500">*</span></label>
                    <select
                      autoComplete="off"
                      name="institute_state"
                      value={form.institute_state}
                      onChange={handleChange}
                      className="font-poppins w-full p-3 outline-none bg-transparent text-[#1111117A] border-[1px] border-[#11111126] rounded-[8px]  border-accent-silver-300 focus:ring-blue-500 focus:border-blue-500  placeholder:text-base placeholder:font-normal text-accent-silver-900 placeholder:text-accent-silver-900"
                    >
                      <option value="">Select State</option>
                      {states.map((state) => (
                        <option key={state.code} value={state.code}>
                          {state.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="block text-[13px] font-medium text-gray-700">Institute Reference No</label>
                    <input
                      autoComplete="off"
                      type="text"
                      name="institute_ref_no"
                      value={form.institute_ref_no}
                      onChange={handleChange}
                      className="mt-1 min-h-[50px] block w-full border-[1px] border-[#11111126] rounded-[8px] text-[#1111117A] shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                </>
              )}

              {form.foreigner_type === "Worker" && (
                <>
                  <div>
                    <label className="block text-[13px] font-medium text-gray-700">Employer Name <span className="text-red-500">*</span></label>
                    <input
                      autoComplete="off"
                      type="text"
                      name="employer_name"
                      value={form.employer_name}
                      onChange={handleChange}
                      className="mt-1 min-h-[50px] block w-full border-[1px] border-[#11111126] rounded-[8px] text-[#1111117A] shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-[13px] font-medium text-gray-700">Employer Address Line 1 <span className="text-red-500">*</span></label>
                    <input
                      autoComplete="off"
                      type="text"
                      name="employer_address_1"
                      value={form.employer_address_1}
                      onChange={handleChange}
                      className="mt-1 min-h-[50px] block w-full text-[#1111117A] border-[1px] border-[#11111126] rounded-[8px] shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-[13px] font-medium text-gray-700">Employer Address Line 2</label>
                    <input
                      autoComplete="off"
                      type="text"
                      name="employer_address_2"
                      value={form.employer_address_2}
                      onChange={handleChange}
                      className="mt-1 min-h-[50px] block w-full text-[#1111117A] border-[1px] border-[#11111126] rounded-[8px] shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-[13px] font-medium text-gray-700">Employer City <span className="text-red-500">*</span></label>
                    <input
                      autoComplete="off"
                      type="text"
                      name="employer_city"
                      value={form.employer_city}
                      onChange={handleChange}
                      className="mt-1 min-h-[50px] block w-full text-[#1111117A] border-[1px] border-[#11111126] rounded-[8px] shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-[13px] font-medium text-gray-700">Employer Postcode <span className="text-red-500">*</span></label>
                    <input
                      autoComplete="off"
                      type="text"
                      name="employer_postal_code"
                      value={form.employer_postal_code}
                      onChange={handleChange}
                      className="mt-1 min-h-[50px] block w-full text-[#1111117A] border-[1px] border-[#11111126] rounded-[8px] shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-[13px] font-medium text-gray-700">Employer State <span className="text-red-500">*</span></label>
                    <select
                      autoComplete="off"
                      name="employer_state"
                      value={form.employer_state}
                      onChange={handleChange}
                      className="font-poppins w-full p-3 rounded-[8px] outline-none bg-transparent text-[#1111117A] border-[1px] border-[#11111126] focus:ring-blue-500 focus:border-blue-500  placeholder:text-base placeholder:font-normal text-accent-silver-900 placeholder:text-accent-silver-900"
                    >
                      <option value="">Select State</option>
                      {states.map((state) => (
                        <option key={state.code} value={state.code}>
                          {state.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="block text-[13px] font-medium text-gray-700">Employee Reference No</label>
                    <input
                      autoComplete="off"
                      type="text"
                      name="emp_ref_no"
                      value={form.emp_ref_no}
                      onChange={handleChange}
                      className="mt-1 min-h-[50px] block w-full text-[#1111117A] border-[1px] border-[#11111126] rounded-[8px] shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                </>
              )}

              {form.foreigner_type === "Tourist" && (
                <div>
                  <label className="block text-[13px] font-medium text-gray-700">Hotel Name <span className="text-red-500">*</span></label>
                  <input
                    autoComplete="off"
                    type="text"
                    name="hotel_name"
                    value={form.hotel_name}
                    onChange={handleChange}
                    className="mt-1 min-h-[50px] block w-full text-[#1111117A] border-[1px] border-[#11111126] rounded-[8px] shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>
              )}

              <div className="flex items-center mt-2">
                <input
                  autoComplete="off"
                  type="checkbox"
                  checked={sameAddress}
                  onChange={(e) => setSameAddress(e.target.checked)}
                  id="sameAddress"
                  className="h-4 min-h-[50px] w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
                <label htmlFor="sameAddress" className="ml-2 text-[13px] font-medium text-gray-700">
                  Address is same as staying address
                </label>
              </div>
            </>
          )}

          {/* Address 1 */}
          <div>
            <label className="block text-[13px] font-medium text-gray-700">Address Line 1 <span className="text-red-500">*</span></label>
            <input
              autoComplete="off"
              type="text"
              name="address1"
              value={form.address1}
              onChange={handleChange}
              className="mt-1 block min-h-[50px] w-full text-[#1111117A] border-[1px] border-[#11111126] rounded-[8px] shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            />
          </div>

          {/* Address 2 */}
          <div>
            <label className="block text-[13px] font-medium text-gray-700">Address Line 2</label>
            <input
              autoComplete="off"
              type="text"
              name="address2"
              value={form.address2}
              onChange={handleChange}
              className="mt-1 block min-h-[50px] w-full text-[#1111117A] border-[1px] border-[#11111126] rounded-[8px] shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            />
          </div>

          {/* City */}
          <div>
            <label className="block text-[13px] font-medium text-gray-700">City <span className="text-red-500">*</span></label>
            <input
              autoComplete="off"
              type="text"
              name="city"
              value={form.city}
              onChange={handleChange}
              className="mt-1 block min-h-[50px] w-full text-[#1111117A] border-[1px] border-[#11111126] rounded-[8px] shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            />
          </div>

          {/* State - Now a dropdown */}
          <div>
            <label className="block  text-[13px] font-medium text-gray-700">State <span className="text-red-500">*</span></label>
            <select
              autoComplete="off"
              name="state"
              value={form.state}
              onChange={handleChange}
              className="font-poppins w-full p-3 rounded-[8px] outline-none bg-transparent text-[#1111117A] border-[1px] border-[#11111126] focus:ring-blue-500 focus:border-blue-500  placeholder:text-base placeholder:font-normal text-accent-silver-900 placeholder:text-accent-silver-900"
            >
              <option value="">Select State</option>
              {states.map((state) => (
                <option key={state.code} value={state.code}>
                  {state.name}
                </option>
              ))}
            </select>
          </div>

          {/* Postcode */}
          <div>
            <label className="block text-[13px] font-medium text-gray-700">Postcode <span className="text-red-500">*</span></label>
            <input
              autoComplete="off"
              type="text"
              name="postal_code"
              value={form.postal_code}
              onChange={handleChange}
              className="mt-1 block min-h-[50px] w-full text-[#1111117A] border-[1px] border-[#11111126] rounded-[8px] shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            />
          </div>

          {/* ICCID with barcode scanner */}
          <div className="relative">
            <label className="block text-[13px] font-medium text-gray-700">ICCID <span className="text-red-500">*</span></label>
            <input
              autoComplete="off"
              type="text"
              name="iccid"
              value={form.iccid}
              onChange={handleChange}
              className="mt-1 block min-h-[50px] w-full text-[#1111117A] border-[1px] border-[#11111126] rounded-[8px] shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            />
            <div className="absolute top-8 right-3">
              <CiBarcode
                className="size-6 cursor-pointer text-gray-500 hover:text-gray-700"
                onClick={handleOpenBarCodeModal}
              />
            </div>
          </div>

          {/* MSISDN - Now a dropdown */}
          <div>
            <label className="block text-[13px] font-medium text-gray-700">Current MSISDN <span className="text-red-500">*</span></label>
            <input
              autoComplete="off"
              type="text"
              name="msisdn"
              value={form.msisdn}
              onChange={handleChange}
              className={`mt-1 block w-full min-h-[50px] text-[#1111117A] border-[1px] rounded-[8px] shadow-sm py-2 px-3 focus:outline-none ${form.msisdn && !/^(60)?[0-9]{8,11}$/.test(form.msisdn)
                ? 'border-red-500 focus:ring-red-500 focus:border-red-500'
                : 'border-[#11111126] focus:ring-blue-500 focus:border-blue-500'
                }`}
            />
            {form.msisdn && !/^(60)?[0-9]{8,11}$/.test(form.msisdn) && (
              <p className="mt-1 text-sm text-red-600">
                Please enter a valid Malaysian phone number (8-11 digits, starting with 60)
              </p>
            )}
          </div>

          {/* Submit Button */}
          <div>
            <button
              type="submit"
              disabled={loading}
              className="mt-2 w-full bg-primary text-white py-4 rounded-full text-[12px] font-[400]"
            >
              Submit
            </button>
          </div>
        </form>
      </div>

      {/* Loading Modal */}
      {loading && (
        <div className="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 flex justify-center items-center h-full w-full md:inset-0 max-h-full bg-black bg-opacity-50">
          <div className="p-4 w-full max-w-md max-h-full">
            <div className="px-7 py-6 bg-white rounded-3xl shadow">
              <div className="flex flex-col gap-2 items-center justify-center pb-7">
                <img src={loadingimage} alt="loading" className="w-20 h-20" />
                <p className="text-base font-semibold">Processing...</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Success Modal */}
      {showSuccess && (
        <SuccessModal
          close={() => {
            setShowSuccess(false);
            navigate("/dealer-register-success?isMNP=true");
          }}
          message={successMessage}
          button1="OK"
        />
      )}

      {/* Error Modal */}
      {showError && <ErrorModal close={() => setShowError(false)} message={errorMessage} />}

      {/* Scanner Modal */}
      {openModal && <ScannerModal closeModal={closeModal} getCode={getCode} />}
    </>
  )
}

export default MNPForm
